import { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { Button, Menu, MenuItem } from '@mui/material';
import { Add as AddIcon, ArrowDropDown as ArrowDropDownIcon } from '@mui/icons-material';

import FormControl from 'material/components/FormControl';
import Select from 'material/components/Select';
import MuiMenuItem from 'material/components/MenuItem';
import TopCard from 'common/containers/TopCard';

const ActionButton = styled(Button)`
  padding: 6px 16px;
`;

const ListsTopCard = ({
  childrenLists,
  listTypeFilter,
  onFilterChange,
  onOpenNewList,
  onOpenNewGroupDialog,
}) => {
  const history = useHistory();
  const { organizationUuid } = useParams();

  const [anchorElement, setAnchorElement] = useState(null);

  const handleClick = event => setAnchorElement(event.currentTarget);
  const handleClose = () => setAnchorElement(null);

  const handleOpenNewList = () => {
    onOpenNewList();
    handleClose();
  };

  return (
    <>
      <TopCard
        title="Lists"
        restActions={
          <>
            <FormControl sx={{ minWidth: 120 }} size="small">
              <Select
                inputProps={{ 'aria-label': 'Filter list type' }}
                onChange={event => onFilterChange(event.target.value)}
                value={listTypeFilter}
                variant="outlined"
              >
                <MuiMenuItem value={0}>All Lists</MuiMenuItem>
                <MuiMenuItem
                  disabled={!childrenLists.find(list => list.type === 'StaticList')}
                  value="StaticList"
                >
                  Static Lists
                </MuiMenuItem>
                <MuiMenuItem
                  disabled={!childrenLists.find(list => list.type === 'ComplexList')}
                  value="ComplexList"
                >
                  Filtered Lists
                </MuiMenuItem>
              </Select>
            </FormControl>
            <ActionButton
              aria-controls="add-list-menu"
              aria-haspopup="true"
              color="secondary"
              disableElevation
              endIcon={<ArrowDropDownIcon />}
              onClick={handleClick}
              startIcon={<AddIcon />}
              variant="contained"
            >
              Add List
            </ActionButton>
            <ActionButton
              color="secondary"
              disableElevation
              onClick={onOpenNewGroupDialog}
              startIcon={<AddIcon />}
              variant="contained"
            >
              Add Group
            </ActionButton>
          </>
        }
      />
      <Menu
        anchorEl={anchorElement}
        id="add-list-menu"
        keepMounted
        onClose={handleClose}
        open={Boolean(anchorElement)}
      >
        <MenuItem onClick={handleOpenNewList}>Static List</MenuItem>
        <MenuItem
          onClick={() => history.push(`/${organizationUuid}/contacts/lists/create-filtered-list`)}
        >
          Filtered List
        </MenuItem>
      </Menu>
    </>
  );
};

ListsTopCard.propTypes = {
  childrenLists: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
    })
  ).isRequired,
  listTypeFilter: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onOpenNewGroupDialog: PropTypes.func.isRequired,
  onOpenNewList: PropTypes.func.isRequired,
};

export default ListsTopCard;
